<template>
  <div class="p-grid" v-if="$ability.can('read', 'User')">
    <div class="p-col-12" v-if="accountId">
      <UserTabs></UserTabs>
    </div>
    <div class="p-col-12">
      <div v-if="loadingList">
        <AppSkeletonTable></AppSkeletonTable>
      </div>
      <DataTable
        v-if="!loadingList"
        :value="resultItems"
        responsiveLayout="stack"
      >
        <Column
          header="ID"
          field="id"
          :sortable="true"
          style="max-width: 80px"
        ></Column>
        <Column
          header="Nome"
          field="name"
          :sortable="true"
          alignFrozen="left"
          :frozen="true"
        ></Column>
        <Column header="Username" field="username" :sortable="true"></Column>
        <Column header="Contatos" field="contacts" style="min-width: 250px">
          <template #body="{ data: { phone, email } }">
            <span v-if="phone || email">
              <span v-if="phone && phone.length === 10">
                Telefone: {{ $formatPhone(phone) }}<br />
              </span>
              <span v-if="phone && phone.length === 11">
                Celular: {{ $formatCellPhone(phone) }}<br />
              </span>
              <span v-if="email"> Email: {{ email }} <br /> </span>
            </span>
            <span v-else> - </span>
          </template>
        </Column>
        <Column
          header="Tipo"
          field="roleId"
          :sortable="true"
          style="min-width: 100px"
        >
          <template #body="{ data: { role } }">
            {{ role?.name || '-' }}
          </template>
        </Column>
        <Column
          header="Status"
          field="status"
          :sortable="true"
          style="min-width: 100px"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data: { status } }">
            <AppStatusTag :status="status"></AppStatusTag>
          </template>
        </Column>
        <Column
          :sortable="!accountId"
          :header="!accountId ? 'Conta' : ''"
          :headerStyle="accountId ? 'width: 0' : ''"
          field="accountName"
          style="min-width: 100px"
        >
          <template #body="{ data: { accountName } }">
            <span v-if="!accountId"> {{ accountName || '-' }}</span>
          </template>
        </Column>
        <Column
          header="Ações"
          style="min-width: 100px"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data }">
            <div>
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-secondary p-mr-1"
                :disabled="!$ability.can('write', 'User')"
                @click="showEdit(data)"
              ></Button>
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-text p-button-secondary"
                :disabled="!$ability.can('delete', 'User')"
                @click="showDeleteConfirm(results, data.id, 'name')"
              ></Button>
            </div>
          </template>
        </Column>
      </DataTable>
      <Paginator
        v-if="!loadingList"
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
      <UserEdit
        ref="userEdit"
        v-model:visible="editVisible"
        @saved="fetchList()"
      ></UserEdit>
      <AppModalDelete
        type="Usuário"
        :visible="deleteConfirm.visible"
        :item="deleteConfirm.item"
        @confirm="onDelete()"
        @cancel="hideDeleteConfirm()"
      ></AppModalDelete>
      <AppFloatButton
        icon="pi pi-plus"
        @click="showEdit()"
        v-if="$ability.can('write', 'User')"
      />
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { useStore, mapGetters } from 'vuex';
import useDeleteConfirm from '../../lib/useDeleteConfirm';
import useApiList from '../../lib/useApiList';
import { UserApi as AdminUserApi } from '../../services/api/admin';
import { UserApi } from '../../services/api';
import UserEdit from './UserEdit.vue';
import UserTabs from './components/UserTabs.vue';

export default {
  name: 'UserList',
  components: {
    UserEdit,
    UserTabs,
  },
  setup() {
    const store = useStore();
    const API = store.getters['app/accountId'] ? UserApi : AdminUserApi;
    return {
      ...useApiList(API),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      editVisible: false,
    };
  },
  async created() {
    await this.fetchList();
    this.$emitter.on('topbar-search', ({ query }) => {
      this.searchList(query);
    });
  },
  computed: {
    ...mapGetters('app', ['accountId']),
    resultItems() {
      return this.results.map((result) => {
        return {
          ...result,
          accountName: result?.account?.name || '',
          phone: result.phone ? result.phone.replace(/\D/g, '') : null,
        };
      });
    },
  },
  methods: {
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
    showEdit(data) {
      this.editVisible = true;
      this.$refs.userEdit.setData(data);
    },
  },
};
</script>

<style scoped>
</style>
